import React from "react"
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"

const NotFound = () => {
  const { t } = useTranslation()
  document.title = t("Page Not Found | Portal")

  return (
    <div className="account-pages">
      <Container
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <Row style={{ justifyContent: "center" }}>
          <Col md={12} lg={12} xl={12}>
            <div className="text-center">
              <div className="mb-4">
                <h1 className="display-1 fw-bold text-primary">404</h1>
                <h4 className="text-uppercase">{t("Page Not Found")}</h4>
                <div className="mt-3">
                  <i className="mdi mdi-map-search-outline display-4 text-primary"></i>
                </div>
              </div>

              <div className="mt-4">
                <h5 className="text-muted">
                  {t("Sorry, the page you are looking for doesn't exist.")}
                </h5>
                <p className="text-muted mb-4">
                  {t(
                    "The URL may be incorrect or the page may have been moved or deleted."
                  )}
                </p>

                <div className="d-flex justify-content-center gap-2">
                  <Link to="/dashboard" className="btn btn-primary">
                    <i className="mdi mdi-home me-1"></i> {t("Go to Dashboard")}
                  </Link>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => window.history.back()}
                  >
                    <i className="mdi mdi-arrow-left me-1"></i> {t("Go Back")}
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default NotFound
